 import React, { useState, forwardRef, useImperativeHandle } from 'react';

const FeastBar = forwardRef(({ handleSectionClick }, ref) => {
  const [visible, setVisible] = useState(false);

  const toggleBar = () => {
    setVisible(prev => !prev);
  };

  // Expose toggleBar to parent via ref
  useImperativeHandle(ref, () => ({
    toggleBar
  }));

  const sections = [
    'DEALS',
    'PIZZAS',
    'SIDES & SALADS',
    'WRAPS & LOADED FRIES',
    'DESSERTS',
    'DRINKS & SHAKES'
  ];

  const barStyle = {
    backgroundColor: '#4B2E2B',
    color: 'white',
    padding: '10px',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    transition: 'all 0.3s ease'
  };

  const itemStyle = {
    margin: '5px 10px',
    cursor: 'pointer',
    fontWeight: 'bold'
  };

  return (
    <div>
   

      {visible && (
        <div style={barStyle}>
          {sections.map(section => (
            <div
              key={section}
              style={itemStyle}
              onClick={() => handleSectionClick(section)}
              onMouseOver={(e) => e.target.style.textDecoration = 'underline'}
              onMouseOut={(e) => e.target.style.textDecoration = 'none'}
            >
              {section}
            </div>
          ))}
        </div>
      )}
    </div>
  );
});

export default FeastBar;
